import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zefDialogClose, onZefDialogOpen } from '@zerops/zef/dialog';
import { ProjectEnvEditForm } from '@zerops/zui/project-env-edit-form';
import { map, filter, switchMap, delay } from 'rxjs/operators';
import { FEATURE_NAME } from './project-env-edit-dialog.constant';
import { updateProjectEnvSuccess } from '@zerops/zerops/core/project-base/project-base.action';
import { ZefSnackService } from '@zerops/zef/snack';
import { ProjectEnvTypes } from '@zerops/models/project';

@Injectable()
export class ProjectEnvEditDialogEffect {

  onDialogOpenFocusInput$ = createEffect(() => this._actions$.pipe(
    onZefDialogOpen(FEATURE_NAME),
    delay(100),
    map(() => this._projectEnvEditForm.focus('key'))
  ));

  #onProjectEnvUpdateSuccess$ = this._actions$.pipe(
    ofType(updateProjectEnvSuccess)
  );

  onUpdateSuccessDialogClose$ = createEffect(() => this.#onProjectEnvUpdateSuccess$.pipe(
    map(() => zefDialogClose({ key: FEATURE_NAME }))
  ));

  onDialogCloseResetForm$ = createEffect(() => this._actions$.pipe(
    ofType(zefDialogClose),
    filter((action) => action?.key === FEATURE_NAME),
    delay(500),
    switchMap(() => [
      this._projectEnvEditForm.reset(),
      this._projectEnvEditForm.setDefaultValues()
    ])
  ));

  onUpdateSuccessNotification$ = createEffect(() => this.#onProjectEnvUpdateSuccess$.pipe(
    filter(({ originalAction }) => originalAction?.meta?.source === FEATURE_NAME),
    switchMap((action) => this._snack.success$({ translation: action?.originalAction?.meta?.type === ProjectEnvTypes.System
      ? `${FEATURE_NAME}.updateGeneratedEnvSuccess`
      : `${FEATURE_NAME}.updateCustomEnvSuccess`
    }))
  ), { dispatch: false });

  constructor(
    private _actions$: Actions,
    private _projectEnvEditForm: ProjectEnvEditForm,
    private _snack: ZefSnackService,
  ) { }
}
